module.exports = __webpack_public_path__ + "img/reasink.299b89bb.jpg";